import { AspectRatioSegmented } from "components/AspectRatioSegmented/";
import {
  DESKTOP_ASPECT_RATIO,
  MOBILE_ASPECT_RATIO,
  TABLET_ASPECT_RATIO,
} from "pages/media/constants/";
import { useTemplateData } from "../../hooks/useTemplateData";
import { useTemplateEditorStore } from "../../store/useTemplateEditorStore";
import { useTemplatesStatusStore } from "../../store/useTemplatesStatusStore";

export const MediaResolutionSegmentedButtons = ({
  vertical = false,
  showLabel = true,
  style,
  _useTemplateData,
  _useTemplateEditorStore,
}: {
  vertical?: boolean;
  showLabel?: boolean;
  style?: React.CSSProperties;
  // to mock hooks in storybook
  _useTemplateData?: typeof useTemplateData;
  _useTemplateEditorStore?: typeof useTemplateEditorStore;
}) => {
  const {
    mediaGenerationSettingsData: { mediaAspectRatio, changeMediaSettingsSizes },
    previewData: { previewSizes },
  } = (_useTemplateData ?? useTemplateData)();

  const { changeTemplatesAspectRatio } = (
    _useTemplateEditorStore ?? useTemplateEditorStore
  )((store) => ({
    changeTemplatesAspectRatio: store.changeTemplatesAspectRatio,
  }));

  const { addBulkTemplateUpdate } = useTemplatesStatusStore((state) => ({
    addBulkTemplateUpdate: state.addBulkTemplateUpdate,
  }));

  const handleAspectRatioChange = (aspectRatio: number) => {
    if (!previewSizes) return;
    changeMediaSettingsSizes(aspectRatio);
    changeTemplatesAspectRatio(aspectRatio, previewSizes.scene);
    addBulkTemplateUpdate();
  };

  return (
    <AspectRatioSegmented
      vertical={vertical}
      showLabel={showLabel}
      style={style}
      value={mediaAspectRatio}
      onChange={handleAspectRatioChange}
      options={[
        { type: "desktop", value: DESKTOP_ASPECT_RATIO },
        { type: "tablet", value: TABLET_ASPECT_RATIO },
        { type: "mobile", value: MOBILE_ASPECT_RATIO },
      ]}
    />
  );
};
